import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './scrollstyle.css'; 

const MovieSlider = () => {
  // State variable for movies
  const [movies, setMovies] = useState([]);

  // Fetch movies from API when the component mounts
  useEffect(() => {
    const fetchMovies = async () => {
      // Fetch the TMDB API key from environment variables
      const apiKey = process.env.REACT_APP_TMDB_API_KEY;
      try {
        // Fetch the trending movies of the week from the TMDB API
        const response = await fetch(
          `https://api.themoviedb.org/3/trending/movie/week?api_key=${apiKey}`
        );
        const data = await response.json();
        // Set the fetched movies to the state
        setMovies(data.results);
      } catch (error) {
        console.error('Error occurred while fetching movies:', error);
      }
    };

    fetchMovies();
  }, []);

  // Configuration settings for the Slider component
  const settings = {
    dots: false, 
    infinite: true, 
    speed: 500, 
    slidesToShow: 7, 
    slidesToScroll: 1, 
    autoplay: true, 
    autoplaySpeed: 3000, 
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5, 
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3, 
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, 
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2, 
        },
      },
    ],
  };

  return (
    <div>
      <h2 id='popular'>Movies of the Week</h2>
      {/* Slider component to display movie posters */}
      <Slider {...settings}>
        {movies.map((movie) => (
          <div key={movie.id} className='rowBox'>
            <Link to={`/movies/${movie.id}`} className="linking">
              <img src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`} alt={movie.title} className='sliding' />
              <h3 className='slideText'>{movie.title}</h3>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MovieSlider;
